import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Masonry from "react-masonry-css";
import ReactHtmlParser from "react-html-parser";

import ProductCard from "../../Shop/ProductCard";
import ProductMeta from "../../Shop/ProductMeta";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const CgbBeerListingBlock = (props) => {
  const classes = useStyles();

  const breakpointColumnsObj = {
    default: 3,
    746: 2,
    480: 1,
  };

  const data = useStaticQuery(graphql`
  query BeerListing {
    allWpBeer {
      nodes {
        acfBeerFields {
          alcoholVolume
          backgroundColor
          backgroundImage {
            mediaItemUrl
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          image {
            mediaItemUrl
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          sweetness
          taste
          bitterness
          beerType
          colorDescription
          description
          dietaryGuidelines
          healthInformationPdf
        }
        databaseId
        slug
        date
        title
      }
    }
  }
  `);

  let beers = data.allWpBeer.nodes;

  beers.sort((a, b) => {
    const keyA = new Date(a.date),
      keyB = new Date(b.date);
    // Compare the 2 dates
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });

  return (
    <div
      className={`beer-listing ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.beerListing} ${classes.beerListingTheme}`}
    >
      <h2>Draught beers in our pubs</h2>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className={classes.masonry}
        columnClassName={classes.masonryColumn}
      >
        {beers.map((beer) => {
          return (
            <ProductCard
              image={beer.acfBeerFields.image.mediaItemUrl}
              product={beer}
              uri={"/our-beers/" + beer.slug}
              title={ReactHtmlParser(beer.title)}
              onSale={false}
              backgroundColor={beer.acfBeerFields.backgroundColor}
              backgroundImage={beer.acfBeerFields.backgroundImage.mediaItemUrl}
            >
              <div className={classes.icons}>
                <ProductMeta
                  beer={beer.acfBeerFields}
                  classes={{ productMeta: "small dark" }}
                />
              </div>
            </ProductCard>
          );
        })}
      </Masonry>
    </div>
  );
};

export const CgbBeerListingBlockFragment = graphql`
  fragment CgbBeerListingBlock on WpBlock {
    ... on WpCgbBeerListingBlock {
      name
      attributes {
        className
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbBeerListingBlockPreview = `
    ... on CgbBeerListingBlock {
        name
        attributes {
            className
        }
    }
`;
